import UpdateIcon from '@mui/icons-material/Update';
import { Tooltip } from '@src/common/components/Tooltip';
import { Typography } from '@src/common/components/Typography';
import { theme } from '@src/common/styles/Theme';
import { colors } from '@src/common/styles/valueTokens';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

type Props = Pick<
  ComponentProps<typeof Typography>,
  'variant' | 'id' | 'children' | 'style' | 'className' | 'component' | 'color'
> & { lastUpdated?: string };

export const UpdatableValue = ({
  lastUpdated,
  style,
  children,
  ...typographyProps
}: Props) => {
  const { t } = useTranslation();
  return (
    <Typography
      {...typographyProps}
      style={{
        display: 'inline-flex',
        gap: theme.spacing['1'],
        ...style,
      }}
    >
      {children}
      {lastUpdated && (
        <Tooltip title={t('updatedOn') + lastUpdated}>
          <UpdateIcon
            sx={{
              fontSize: '1.4em',
              verticalAlign: 'middle',
              color: colors.tertiary['60'],
            }}
          />
        </Tooltip>
      )}
    </Typography>
  );
};
